import React, {Suspense} from "react";
import {Switch, Route, withRouter} from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import {useLastLocation} from "react-router-last-location";
import {LayoutContextProvider} from "../../_metronic";
import * as routerHelpers from "../router/RouterHelpers";
import MainPanel from "./MainPanel";
import UsinaPanel from "./UsinaPanel";
import Auth from "./Auth";
import {connect} from 'react-redux';
import {LayoutSplashScreen} from "../../_metronic";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import LimpezaChecklistVerify from "../pages/home/limpeza/LimpezaChecklistVerify";
import ConfirmarEmail from "../pages/auth/ConfirmarEmail";

const Routes = withRouter(({history, user}) => {
    const lastLocation = useLastLocation();
    routerHelpers.saveLastLocation(lastLocation);
    const {isAuthorized, menuConfig, userLastLocation} = useSelector(
        ({auth, urls, builder: {menuConfig}}) => ({
            menuConfig,
            isAuthorized: auth.user != null,
            userLastLocation: routerHelpers.getLastLocation()
        }),
        shallowEqual
    );

    const isUserUsina = user?.empresa_tipo && user?.empresa_tipo?.toLowerCase() === "usina";
    const isUserPatio = !isUserUsina;

    return (
        <LayoutContextProvider history={history} menuConfig={menuConfig}>
            <Suspense fallback={<LayoutSplashScreen/>}>
                <Switch>
                    <Route path="/error" component={ErrorsPage}/>
                    <Route path="/logout" component={LogoutPage}/>
                    <Route path="/limpeza-checklist/verify/:code" component={LimpezaChecklistVerify} />
                    <Route path="/verificar-email" component={ConfirmarEmail} />
                    {(!isAuthorized) && <Auth />}
                    {isUserUsina && <UsinaPanel />}
                    {isUserPatio && <MainPanel />}
                </Switch>
            </Suspense>
        </LayoutContextProvider>
    );
});

const mapStateToProps = ({auth: {user}}) => ({user});
export default connect(mapStateToProps)(Routes);